import { component } from 'picoapp';

export default component(async (node) => {
  const swiperMain = node.querySelector('[data-swiper-main]');
  const swiperThumbs = node.querySelector('[data-swiper-thumbs]');

  let Swiper = null;
  Swiper = (await import(
    /* webpackChunkName: "swiper" */
    'modules/swiper'
  )).default;

  const swiperMainConfig = {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 500,
    autoplay: {
      delay: 10000,
    },
  };

  const swiperThumbsConfig = {
    slidesPerView: 13,
  };

  const initSliderThumbs = new Swiper(swiperThumbs, swiperThumbsConfig);
  const initSliderMain = new Swiper(swiperMain, {
    ...swiperMainConfig,
    thumbs: {
      swiper: initSliderThumbs,
    },
    scrollbar: {
      el: '.timeline',
      draggable: true,
    },
  });

  initSliderThumbs.init();
  initSliderMain.init();
});
